import { render, staticRenderFns } from "./flugstrecken-vergleich-layout.vue?vue&type=template&id=fb97c194&scoped=true"
import script from "./flugstrecken-vergleich-layout.vue?vue&type=script&lang=js"
export * from "./flugstrecken-vergleich-layout.vue?vue&type=script&lang=js"
import style0 from "./flugstrecken-vergleich-layout.vue?vue&type=style&index=0&id=fb97c194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb97c194",
  null
  
)

export default component.exports